import React from 'react';
import './PetAnimations.css';

export default function NimbusPupSvg({ size = 120, color, className = '' }) {
  const cloudColor = color || '#FFFFFF';
  const cloudShade = '#D8E8F4';
  const skyBlue = '#7FB8E0';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer soft glow */}
      <circle cx="60" cy="60" r="44" fill={skyBlue} opacity="0.1" />
      {/* Cloud body (bumpy puffs) */}
      <circle cx="36" cy="74" r="14" fill={cloudShade} />
      <circle cx="84" cy="74" r="14" fill={cloudShade} />
      <ellipse cx="60" cy="78" rx="26" ry="14" fill={cloudShade} />
      <circle cx="36" cy="70" r="14" fill={cloudColor} />
      <circle cx="84" cy="70" r="14" fill={cloudColor} />
      <ellipse cx="60" cy="74" rx="26" ry="14" fill={cloudColor} />
      {/* Cloud head puffs */}
      <circle cx="42" cy="46" r="14" fill={cloudColor} />
      <circle cx="78" cy="46" r="14" fill={cloudColor} />
      <ellipse cx="60" cy="42" rx="22" ry="18" fill={cloudColor} />
      {/* Floppy ears (cloud puffs) */}
      <ellipse cx="36" cy="38" rx="8" ry="10" fill={cloudShade} />
      <ellipse cx="84" cy="38" rx="8" ry="10" fill={cloudShade} />
      <ellipse cx="38" cy="36" rx="6" ry="8" fill={cloudColor} />
      <ellipse cx="82" cy="36" rx="6" ry="8" fill={cloudColor} />
      {/* Eyes */}
      <ellipse cx="52" cy="44" rx="3.5" ry="4" fill="#2C2419" />
      <ellipse cx="68" cy="44" rx="3.5" ry="4" fill="#2C2419" />
      <circle cx="53" cy="42.5" r="1.2" fill="white" />
      <circle cx="69" cy="42.5" r="1.2" fill="white" />
      {/* Nose */}
      <ellipse cx="60" cy="52" rx="3" ry="2" fill={skyBlue} />
      {/* Mouth (puppy smile) */}
      <path d="M60 54C58 56 55 56 54 55" stroke={skyBlue} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      <path d="M60 54C62 56 65 56 66 55" stroke={skyBlue} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      {/* Pink tongue */}
      <ellipse cx="60" cy="57" rx="2.5" ry="2" fill="#F8A8B8" />
      {/* Tiny rain drops below */}
      <ellipse cx="44" cy="98" rx="1.5" ry="3" fill={skyBlue} opacity="0.6" />
      <ellipse cx="60" cy="100" rx="1.5" ry="3" fill={skyBlue} opacity="0.6" />
      <ellipse cx="76" cy="98" rx="1.5" ry="3" fill={skyBlue} opacity="0.6" />
    </svg>
  );
}
